import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { GetMyPassengerResponse } from '../../types/auth.js'

import { apiClient } from '../../lib/client.js'
import { meKeys } from './keys.js'

interface DeleteMyIdentityDocumentParams {
  documentId: string
  passengerId: string
}

export const useDeleteMyIdentityDocumentMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ documentId, passengerId }: DeleteMyIdentityDocumentParams) => {
      await apiClient.client.delete(
        `/me/passengers/${passengerId}/identity-documents/${documentId}`
      )
    },
    onError: () => {
      void queryClient.invalidateQueries({ queryKey: meKeys.passengers })
    },
    onMutate: async ({ documentId, passengerId }) => {
      await queryClient.cancelQueries({ queryKey: meKeys.passengers })

      const previousPassengers = queryClient.getQueryData<GetMyPassengerResponse[]>(
        meKeys.passengers
      )

      if (previousPassengers) {
        queryClient.setQueryData<GetMyPassengerResponse[]>(
          meKeys.passengers,
          previousPassengers.map((p) =>
            p.id === passengerId
              ? {
                  ...p,
                  identityDocuments: p.identityDocuments.filter((doc) => doc.id !== documentId),
                }
              : p
          )
        )
      }

      return { previousPassengers }
    },
  })
}
